import '../css/main.css'

import { createPinia } from 'pinia'
import { createApp, h } from 'vue'
import { createInertiaApp, usePage } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from 'ziggy-js';
import translation from './translation.js'
import { useMainStore } from '@/stores/main.js'
import vuetify from './vuetify'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
//import { router } from '@/router';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Iuromat'
const pinia = createPinia()

createInertiaApp({
    //title: (title) => `${title} - ${appName}`, // TODO title not working
    resolve: (name) =>
        resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        /*if (props.initialPage.props.auth.user) {
          useMainStore().setUser({
            name: props.initialPage.props.auth.user.name + " " + props.initialPage.props.auth.user.last_name,
            email:props.initialPage.props.auth.user.email,
          })
        }*/
        return createApp({
            render: () => h(App, props),
            mounted() {
                window.addEventListener("resize", this.updateWidth);
            },
            unmounted() {
                window.removeEventListener("resize", this.updateWidth);
            },
            methods: {
                updateWidth(e) {
                    useMainStore().resized(window.innerWidth)
                }
            }
        })
        .mixin(translation)
        .use(plugin)
        .use(pinia)
        .use(ZiggyVue, Ziggy)
        .use(vuetify)
        .use(VueDatePicker)
        //.use(router)
        .mount(el)
    },
    progress: {
        color: '#4B5563'
    },

})
